import { RootState } from 'src/state/store'

export const selectVizionEmbedUrl = (state: RootState): string | null =>
  state.vizionEmbedUrl?.embedurl ?? null
